module.exports = __webpack_public_path__ + "img/FERCAM_ICONE_DIVISIONALI_RGB-15.bc14c1b1.png";